/**
 * Natural Herbs and Supplements — USD price estimate for US visitors
 * Shows an approximate USD price next to the store's AED price for visitors
 * detected as being in the United States. Does NOT change checkout currency —
 * checkout always charges in AED via Stripe. This is a display-only estimate.
 */
(function () {
  var FALLBACK_RATE = 0.2723; // approx AED -> USD, used only if live rate fetch fails
  var RATE_CACHE_KEY = 'nhs_aed_usd_rate';
  var RATE_CACHE_TTL_MS = 1000 * 60 * 60 * 6; // 6 hours
  var COUNTRY_CACHE_KEY = 'nhs_visitor_country';
  var COUNTRY_CACHE_TTL_MS = 1000 * 60 * 60 * 6; // 6 hours

  function getCachedCountry() {
    try {
      var cached = JSON.parse(sessionStorage.getItem(COUNTRY_CACHE_KEY));
      if (cached && Date.now() - cached.time < COUNTRY_CACHE_TTL_MS) {
        return cached.country;
      }
    } catch (e) {}
    return null;
  }

  function setCachedCountry(country) {
    try {
      sessionStorage.setItem(COUNTRY_CACHE_KEY, JSON.stringify({ country: country, time: Date.now() }));
    } catch (e) {}
  }

  function detectCountry(callback) {
    var params = new URLSearchParams(window.location.search);
    var forced = params.get('preview_country');
    if (forced) {
      var upper = forced.toUpperCase();
      setCachedCountry(upper);
      callback(upper);
      return;
    }

    var cached = getCachedCountry();
    if (cached) {
      callback(cached);
      return;
    }
    fetch('https://ipwho.is/?fields=country_code')
      .then(function (res) {
        if (!res.ok) throw new Error('geo lookup failed');
        return res.json();
      })
      .then(function (data) {
        var country = (data && data.country_code) || null;
        if (country) setCachedCountry(country);
        callback(country);
      })
      .catch(function () {
        callback(null);
      });
  }

  function getCachedRate() {
    try {
      var cached = JSON.parse(sessionStorage.getItem(RATE_CACHE_KEY));
      if (cached && Date.now() - cached.time < RATE_CACHE_TTL_MS) {
        return cached.rate;
      }
    } catch (e) {}
    return null;
  }

  function setCachedRate(rate) {
    try {
      sessionStorage.setItem(RATE_CACHE_KEY, JSON.stringify({ rate: rate, time: Date.now() }));
    } catch (e) {}
  }

  function formatUsd(aedAmount, rate) {
    var usd = aedAmount * rate;
    // round up to nearest .99 for a cleaner displayed estimate
    usd = Math.ceil(usd) - 0.01;
    if (usd < 0) usd = 0;
    return usd.toFixed(2);
  }

  function applyEstimates(rate) {
    var priceEls = document.querySelectorAll('[data-aed-price]');
    priceEls.forEach(function (el) {
      if (el.dataset.usdApplied === '1') return;
      var aed = parseFloat(el.getAttribute('data-aed-price'));
      if (isNaN(aed)) return;
      var usd = formatUsd(aed, rate);
      var estimate = document.createElement('span');
      estimate.className = 'nhs-usd-estimate';
      estimate.style.cssText = 'display:inline-block;margin-left:0.5em;font-size:0.85em;opacity:0.75;';
      estimate.textContent = '(\u2248 $' + usd + ' USD)';
      el.insertAdjacentElement('afterend', estimate);
      el.dataset.usdApplied = '1';
    });
  }

  function showDisclaimerBanner() {
    if (sessionStorage.getItem('nhs_usd_banner_dismissed') === '1') return;
    if (document.getElementById('nhs-usd-banner')) return;

    var banner = document.createElement('div');
    banner.id = 'nhs-usd-banner';
    banner.style.cssText =
      'position:relative;width:100%;box-sizing:border-box;padding:10px 40px 10px 16px;' +
      'background:#fff8e1;color:#5c4a1a;font-size:13px;text-align:center;' +
      'border-bottom:1px solid #e0cf8f;z-index:9999;';
    banner.innerHTML =
      'Prices shown in USD are estimates for your convenience. ' +
      'You will be charged the AED equivalent at checkout (your card issuer sets the final exchange rate).';

    var closeBtn = document.createElement('button');
    closeBtn.setAttribute('aria-label', 'Dismiss');
    closeBtn.textContent = '\u2715';
    closeBtn.style.cssText =
      'position:absolute;right:10px;top:50%;transform:translateY(-50%);' +
      'background:none;border:none;font-size:14px;cursor:pointer;color:#5c4a1a;';
    closeBtn.addEventListener('click', function () {
      banner.remove();
      try {
        sessionStorage.setItem('nhs_usd_banner_dismissed', '1');
      } catch (e) {}
    });

    banner.appendChild(closeBtn);
    document.body.insertBefore(banner, document.body.firstChild);
  }

  var FREE_SHIPPING_THRESHOLD_AED = 1000; // must match the real Shopify US shipping zone condition
  var STANDARD_SHIPPING_RATE_AED = 180; // must match the real Shopify US "Standard Shipping" rate

  function fetchCartTotalAed(callback) {
    fetch('/cart.js')
      .then(function (res) {
        if (!res.ok) throw new Error('cart fetch failed');
        return res.json();
      })
      .then(function (cart) {
        callback((cart && cart.total_price ? cart.total_price : 0) / 100);
      })
      .catch(function () {
        callback(null);
      });
  }

  function renderShippingBanner(rate, cartTotalAed) {
    var existing = document.getElementById('nhs-shipping-banner');
    if (existing) existing.remove();

    var banner = document.createElement('div');
    banner.id = 'nhs-shipping-banner';
    banner.style.cssText =
      'width:100%;box-sizing:border-box;padding:8px 16px;' +
      'background:#0f3d2e;color:#ffffff;font-size:13px;font-weight:600;' +
      'text-align:center;z-index:9998;';

    if (cartTotalAed === null) {
      var thresholdUsd = formatUsd(FREE_SHIPPING_THRESHOLD_AED, rate);
      banner.textContent =
        'Free US shipping on orders over $' + thresholdUsd + ' \u2014 otherwise a flat $' + formatUsd(STANDARD_SHIPPING_RATE_AED, rate) + ' shipping fee applies.';
    } else if (cartTotalAed >= FREE_SHIPPING_THRESHOLD_AED) {
      banner.textContent = '\u2713 You\u2019ve unlocked free US shipping!';
    } else {
      var remainingAed = FREE_SHIPPING_THRESHOLD_AED - cartTotalAed;
      var remainingUsd = formatUsd(remainingAed, rate);
      banner.textContent = 'You\u2019re $' + remainingUsd + ' away from free US shipping!';
    }

    var disclaimerBanner = document.getElementById('nhs-usd-banner');
    if (disclaimerBanner) {
      disclaimerBanner.insertAdjacentElement('afterend', banner);
    } else {
      document.body.insertBefore(banner, document.body.firstChild);
    }
  }

  function updateShippingBanner(rate) {
    fetchCartTotalAed(function (cartTotalAed) {
      renderShippingBanner(rate, cartTotalAed);
    });
  }

  function watchCartChanges(rate) {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var result = originalFetch.apply(this, arguments);
      var url = arguments[0] && arguments[0].toString ? arguments[0].toString() : '';
      if (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) {
        result.then(function () {
          updateShippingBanner(rate);
        });
      }
      return result;
    };
  }

  function init(rate) {
    showDisclaimerBanner();
    updateShippingBanner(rate);
    watchCartChanges(rate);
    applyEstimates(rate);
    var observer = new MutationObserver(function () {
      applyEstimates(rate);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function startPriceLogic() {
    var cachedRate = getCachedRate();
    if (cachedRate) {
      init(cachedRate);
      return;
    }

    fetch('https://api.frankfurter.app/latest?from=AED&to=USD')
      .then(function (res) {
        if (!res.ok) throw new Error('rate fetch failed');
        return res.json();
      })
      .then(function (data) {
        var rate = (data && data.rates && data.rates.USD) || FALLBACK_RATE;
        setCachedRate(rate);
        init(rate);
      })
      .catch(function () {
        init(FALLBACK_RATE);
      });
  }

  detectCountry(function (country) {
    if (country !== 'US') return;
    startPriceLogic();
  });
})();
